import gatewayMixin from "../../mixin/gateway.mixin";

export interface GatewayState {
    gateways: Array<Gateway>;
    status: Array<GatewayStatus>;
    folderState: boolean;
    reduceTreeview: boolean;
    showName: boolean;
    sortTreeview: boolean;
    search: string;
}

export interface Gateway {
    id: string;
    number: number;
    status: number;
    path: string;
}

export interface GatewayStatus {
    gateway: string;
    topic: string;
    field: string;
    value: string;
    timestamp: string;
}

export default {
    namespaced: true,
    state: (): GatewayState => ({
        gateways: [],
        status: [],
        folderState: false,
        reduceTreeview: false,
        showName: true,
        sortTreeview: false,
        search: "",
    }),
    getters: {
        getGatewayByName: (state) => (name) => {
            return state.gateways.find((item) => gatewayMixin.methods.formatGatewayName(item.number).toLowerCase() == name.toLowerCase());
        },
        gateway_lookup(state) {
            return state.gateways.map((item) => ({
                number: item.nubmer,
                name: gatewayMixin.methods.formatGatewayName(item.number).toLowerCase(),
                alias: item.name,
            }));
        },
    },
    mutations: {
        setGateways(state, value) {
            state.gateways = value;
        },
        setStatus(state, value) {
            state.status = value;
        },
        setFolderState(state, value) {
            state.folderState = value;
        },
        setReduceTreeview(state, value) {
            state.reduceTreeview = value;
        },
        setShowName(state, value) {
            state.showName = value;
        },
        setSortTreeview(state, value) {
            state.sortTreeview = value;
        },
        setSearch(state, value) {
            state.search = value;
        },
    },
    actions: {
        fetchGateways(state) {
            this._vm.axios
                .get("/gateway")
                .then((res) => state.commit("setGateways", res.data))
                .catch(() =>
                    state.commit("ui/logMessage", { logLevel: 0, message: "Die Gateway Daten konnten nicht geladen werden." }, { root: true })
                );
        },
        fetchStatus(state) {
            this._vm.axios
                .post("/monitoring/last", { topic: ["general"], field: ["status"] })
                .then((res) => state.commit("setStatus", res.data))
                .catch(() =>
                    state.commit("ui/logMessage", { logLevel: 0, message: "Die GatewayStatus Daten konnten nicht geladen werden." }, { root: true })
                );
        },
    },
    modules: {},
};
